import { fromJS } from "immutable"

const initBrqaData = fromJS({
  
})

const initFilterDataBrqa= fromJS({
  clientName:'',
  clientCode:'',
  retNumber:'',
  customerName:'',
  pageNo:1,
  pageSize:10,
})

export function brqaData(
  state = initBrqaData,
  action
) {
  switch (action.type) {
    case "BRQA_FETCH_DATA_SUCCESS":
      return fromJS(action.dataBrqa);
    default:
      return state;
  }
}

export function filterDataBrqa(
  state = initFilterDataBrqa,
  action
){
  switch (action.type) {
    case "FILTER_SET_CLIENT_NAME_SUCCESS":
      return state.set('clientName', action.clientName)
    case "FILTER_SET_CLIENT_CODE_SUCCESS":
      return state.set('clientCode', action.clientCode)
    case "FILTER_SET_RET_NUMBER_SUCCESS":
      return state.set('retNumber', action.retNumber)
      case "FILTER_SET_CUSTOMER_NAME_SUCCESS":
      return state.set('customerName', action.customerName)
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set('pageNo', action.pageNo)
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set('pageSize', action.pageSize)
    default:
      return state;
  }
}
export function approvalBrqaDetail(
  state= fromJS([]),
  action
){
  switch (action.type) {
    case "APPROVAL_BRQA_DETAIL_FETCH":
      return fromJS(action.detail);
    default:
      return state;
  }
}

export function valueBrqaData(state = fromJS([]), action) {
  switch (action.type) {
    case "VALUE_BRQA_DATA_SUCCESS":
      return fromJS(action.detail);
    default:
      return state;
  }
}


